module.exports = __webpack_public_path__ + "static/media/bkLogo.2e1e9383.png";